import { Outlet } from 'react-router'
import { AppSidebar } from '@/shared/components/app-sidebar'
import HeaderNav from '@/shared/components/header-nav'
import { SidePanel } from '@/shared/components/side-panel/side-panel'
import { cn } from '@/shared/lib/utils'
import { SidebarProvider } from '@/shared/ui/sidebar'

const LayoutAdmin = () => {
  return (
    <SidebarProvider>
      <AppSidebar />
      <main
        className={cn(
          'bg-sidebar relative flex h-screen flex-1 flex-col min-w-0',
          'peer-data-[variant=inset]:min-h-[calc(100svh-var(--spacing-4))] md:peer-data-[variant=inset]:m-2 md:peer-data-[state=collapsed]:peer-data-[variant=inset]:ml-2 md:peer-data-[variant=inset]:ml-0 md:peer-data-[variant=inset]:rounded-xl md:peer-data-[variant=inset]:shadow-sm'
        )}
      >
        <HeaderNav />
        <div className="flex-1 overflow-hidden bg-transparent pt-1 px-2 pb-2">
          <div className="h-full w-full overflow-hidden flex">
            <div className="flex-1 min-w-0 overflow-auto bg-background rounded-xl border border-accent">
              <Outlet />
            </div>
            <SidePanel />
          </div>
        </div>
      </main>
    </SidebarProvider>
  )
}

export default LayoutAdmin
